module.exports = __webpack_public_path__ + "static/four-013a982e83bcfa09507a4508e32d09c3.jpeg";